// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/transact-premium/style.scss
// module id = 6
// module chunks = 0